import * as React from 'react';
import { GraphqlQuery } from 'requestapijs';
import { questionnairesListQuery } from './constant';
import {
  QuestionnaireNodeConnection,
  QuestionNodeConnection, QuestionQuestionType,
  QuestionNode,
} from '../../../schema';
import { Skeleton, RadioGroup, Radio, CheckBox, Button } from 'sha-el-design/lib';
import { nestedAccess } from 'sha-el-design/lib/helpers';
import { fromGlobalId } from '../../helpers';

export const Questions: React.StatelessComponent<Props> = (props) => {
  const [afterStack, changeStack] = React.useState(['']);
  return (
    <GraphqlQuery
      queryString={questionnairesListQuery}
      variables={{
        stateTown: `${props.state},${props.town}`,
        after: afterStack[afterStack.length - 1],
      }}
      render={(response: { allQuestionnaires: QuestionnaireNodeConnection }, error, loading) => {
        if (error) {
          return <div>Something went wrong</div>;
        }

        return (
          <Skeleton
            isLoading={loading}
            render={() => {
              const questionnaires = nestedAccess(response, 'allQuestionnaires', 'edges');

              if (questionnaires) {
                return (
                  <div>
                    {questionnaires.map(
                      (questionnaire, i) => (
                        <div key={i}>
                          <h3>{questionnaire.node.name}</h3>
                          {questionnaire.node.openingStatement && <p>
                            <span style={{fontWeight: 'bold'}}>Opening Statement: </span>
                            {questionnaire.node.openingStatement}
                          </p>}
                          {(questionnaire.node.allQuestions as unknown as QuestionNode[]).map(
                            (v, inx) => {
                              return (
                                <div key={inx} style={{ margin: '10px' }}>
                                  <h4 style={{ margin: 0 }}>{v.name}</h4>
                                  <p style={{ margin: 0 }}>{v.description}</p>
                                  <div style={{ margin: '10px 0' }}>
                                    {questionOptions(
                                      v,
                                      props.questionResponse[inx],
                                      (value) => props.onChange(fromGlobalId(v.id).toString(), value, inx),
                                    )}
                                    <div style={{ color: 'red' }}>{nestedAccess(props.error, inx, 'response')}</div>
                                  </div>
                                </div>
                              );
                            },
                          )}
                          {questionnaire.node.closingStatement && <p>
                            <span style={{fontWeight: 'bold'}}>Closing Statement: </span>
                            {questionnaire.node.closingStatement}
                          </p>}
                        </div>
                      ),
                    )}
                  </div>
                );
              }
              return <h3>Questionnaire Not Available</h3>;
            }}
          />
        );
      }}
    />
  );
};

const questionOptions = (
  question: QuestionNode,
  questionResponse,
  onChange,
) => {
  switch (question.questionType) {
    case QuestionQuestionType.TEXT: {
      return (
        <>
          <textarea
            value={questionResponse}
            onChange={(e) => onChange(e.target.value)}
          />
        </>
      );
    }
    case QuestionQuestionType.SINGLE_CHOICE: {
      return (
        <>
          <RadioGroup value={questionResponse} name={question.id} onChange={(e) => onChange(e.target.value)}>
            {question.options.map(
              (v) => <Radio key={v} value={v} label={v} />,
            )}
          </RadioGroup>
        </>
      );
    }
    case QuestionQuestionType.MULTIPLE_CHOICE: {
      return (
        question.options.map(
          (v, inx) => (
            <>
              <CheckBox
                key={v}
                checked={questionResponse && (questionResponse as string[]).includes(v)}
                label={v}
                onChange={(e) => {
                  if (e.target.checked) {
                    if (Array.isArray(questionResponse)) {
                      return onChange(
                        Array.from(new Set([...questionResponse, v])),
                      );
                    }
                    return onChange(
                      [questionResponse, v],
                    );
                  }
                  const resp = [...questionResponse];
                  resp.splice((questionResponse as string[]).findIndex((opt) => opt === v), 1);
                  onChange(resp);
                }}
              />
            </>
          ),
        )
      );
    }
  }
};

interface Props {
  state: string;
  town: string;
  questionResponse: Array<string | string[]>;
  onChange: (id: string, response: string, index: number) => void;
  onNext: () => void;
  error: any;
}
